import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { PackageWithGroupsResponse } from '@/features/case-list/api/types';
import { OneRosterApiTyped } from '@/lib/http.server';
import { standardMiddlewares } from '@/middlewares/standardMiddlewares';

const fetchOnerosterPackageWithGroups = async (
  onerosterApi: OneRosterApiTyped,
  packageId: string
) => {
  const response = await onerosterApi.GET(
    `/ims/case/v1p1/CFPackages/${packageId}/groups` as any,
    {}
  );

  return response.data;
};

type GetPackageWithGroupsResponse = {
  data: PackageWithGroupsResponse | null;
  success: boolean;
  error: string | null;
};

export const getPackageWithGroups = createServerFn({ method: 'POST' })
  .middleware([standardMiddlewares])
  .validator(
    z.object({
      packageId: z.string(),
    })
  )
  .handler(async ({ context: { oneRosterApiTyped }, data }) => {
    const response = await fetchOnerosterPackageWithGroups(
      oneRosterApiTyped,
      data.packageId
    );
    return {
      data: response as PackageWithGroupsResponse,
      success: true,
      error: null,
    } as GetPackageWithGroupsResponse;
  });
